import { MenuItem, Select } from '@mui/material';
import { useState } from 'react';

import { type VeranstaltungFromSearch } from '../../../dtos';
import { type FilterCallback } from '../types';
import { LoadingCard } from './LoadingCard';
import { SearchResultCard } from './SearchResultCard';

type SearchResultContentProps = {
  readonly veranstaltungen: VeranstaltungFromSearch[];
  readonly loading?: boolean;
  readonly filterCallback: FilterCallback;
};

export const SearchResultContent: React.FC<SearchResultContentProps> = ({
  filterCallback,
  veranstaltungen,
  loading,
}: SearchResultContentProps) => {
  const [sort, setSort] = useState('dateasc');

  const handleSortChange = (newSort: string): void => {
    setSort(newSort);

    switch (newSort) {
      case 'dateasc':
        filterCallback({ sortfield: 'ablauf', sort: 'asc' });
        break;
      case 'datedesc':
        filterCallback({ sortfield: 'ablauf', sort: 'desc' });
        break;
      case 'titleasc':
        filterCallback({ sortfield: 'titel', sort: 'asc' });
        break;
      case 'titledesc':
        filterCallback({ sortfield: 'titel', sort: 'desc' });
        break;
    }
  };

  return (
    <div style={{ padding: 2, display: 'flex', alignItems: 'end', flexDirection: 'column', width: '100%' }}>
      <Select
        variant="standard"
        sx={{ width: '10rem', display: 'flex' }}
        value={sort}
        onChange={(e) => handleSortChange(e.target.value)}
        disableUnderline
        inputProps={{ sx: { fontSize: 14 } }}
      >
        <MenuItem value="dateasc">Datum aufwärts</MenuItem>
        <MenuItem value="datedesc">Datum abwärts</MenuItem>
        <MenuItem value="titleasc">Title aufwärts</MenuItem>
        <MenuItem value="titledesc">Title abwärts</MenuItem>
      </Select>
      {loading ? (
        <>
          <LoadingCard />
          <LoadingCard />
          <LoadingCard />
          <LoadingCard />
        </>
      ) : (
        veranstaltungen.map((veranstaltung) => (
          <SearchResultCard key={veranstaltung.id} veranstaltung={veranstaltung} />
        ))
      )}
    </div>
  );
};
